import React, { memo, useMemo } from 'react';

/**
 *
 * @prop message - it show the message in copliot chat
 * @prop speaker - it will give who is messaging user or saleshandy-copilot.
 *
 * @returns React Component
 */
const AiSpeakerMessage: React.FC<{
  message: React.ReactNode;
  speaker: string;
}> = ({ message = '', speaker = 'user' }) => {
  const isUser = useMemo(() => speaker === 'user', [speaker]);
  return (
    <div
      className={`ai-speaker-message-container ${
        isUser ? 'user' : 'saleshandy-copilot'
      }`}
    >
      <span className="ai-speaker-message-content">{message}</span>
    </div>
  );
};

export default memo(AiSpeakerMessage);
